<!-- 平台信息管理 -->
<template>
  <!-- 院校管理 -->
  <div class="page">
    <div class="paginations" :style="{ filter: this.$store.state.isVague ? 'blur(2px)' : '' }">
      <div class="table-search-box table-search-box-hander">
        <el-form :inline="true" :model="searchData" class="demo-form-inline">
          <!-- 防止输入框回车刷新页面 -->
          <el-form-item label="" v-show="false">
            <el-input></el-input>
          </el-form-item>
          <el-form-item label="平台名称：">
            <el-input
              size="small"
              v-model="searchData.platForm"
              placeholder="请输入平台名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="推送类型：">
            <el-select size="small" v-model="projectType" clearable>
              <el-option
                v-for="item in projectTypeList"
                :key="item.value"
                :value="item.value"
                :label="item.name"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <div class="search_button">
              <i class="pointer el-icon-search" @click="search()"></i>
              <i class="pointer el-icon-refresh-left" @click="reset"></i>
            </div>
          </el-form-item>
        </el-form>
        <div class="addition">
          <el-button @click="add">
            添加
            <i class="h_icon icon-add"></i>
          </el-button>
        </div>
      </div>

      <div class="table_box">
        <el-table :data="tableObj.list">
          <el-table-column prop="platform" label="平台名称"></el-table-column>
          <el-table-column prop="unit" label="单位名称"></el-table-column>
          <el-table-column prop="projectTypeName" label="推送类型"></el-table-column>
          <el-table-column prop="zykCountNum" label="资源库数量"></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <i class="icona icon-edit" title="编辑" @click="edit(scope.row)"></i>
              <i class="icona icon-delete" title="删除" @click="cutOut(scope.row.id)"></i>
            </template>
          </el-table-column>
        </el-table>
        <pageNumber
          :paginations="7"
          :pageNum="searchData.pageDto.pageNum"
          :isPageSizes="true"
          :page-size="searchData.pageDto.pageSize"
          :total="tableObj.total"
          :jumpTo="tableObj.jumpTo"
          @currentChange="search"
        ></pageNumber>
      </div>
    </div>

    <!-- 添加弹窗 -->
    <el-dialog
      :title="uploadBox.title"
      :visible.sync="uploadBox.show"
      :close-on-click-modal="false"
      class="pop_up"
      append-to-body
      :before-close="handleClose"
      @opened="opened"
    >
      <el-form ref="uploadBox" :model="uploadBox.data" :rules="uploadBox.rules" label-width="88px">
        <el-form-item
          v-for="(item, index) in formItemGroup"
          :key="index"
          :label="item.label + '：'"
          :prop="item.prop"
        >
          <el-input
            v-if="item.option === 'input'"
            size="small"
            v-model="uploadBox.data[item.prop]"
            :placeholder="item.placeholder"
          ></el-input>
          <el-select
            v-if="item.option === 'select'"
            v-model="uploadBox.data[item.prop]"
            :placeholder="item.placeholder"
            :popper-append-to-body="false"
            size="small"
            :clearable="item.clearable"
            style="width: 100%"
          >
            <el-option
              v-for="(obj, i) in item.selectList"
              :key="i"
              :label="obj.name"
              :value="obj.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div class="tx-center">
        <el-button size="small" @click="sureClick">确定</el-button>
        <el-button size="small" @click="handleClose">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import pageNumber from "@/components/pageNumber.vue"; //分页
export default {
  components: {
    pageNumber,
  },
  data() {
    return {
      // 查询条件
      searchData: {
        platForm: "", //平台名称
        projectType: "", //推送类型
        pageDto: {
          pageNum: 1, //当前显示的页面页码数
          pageSize: 10,
        },
      },
      projectType: "",
      // 推送类型
      projectTypeList: [
        {
          value: 1,
          name: "国家级",
        },
        {
          value: 2,
          name: "省级",
        },
        {
          value: 3,
          name: "校级",
        },
      ],
      // 表格数据
      tableObj: {
        total: 0,
        jumpTo: 1,
        list: [],
      },
      // 新增弹窗
      uploadBox: {
        show: false,
        title: "",
        data: {
          id: null,
          platform: "", //平台名称
          pushType: "", //推送类型
          projectType: "", //推送类型
          unit: "", //单位名称
        },
        rules: {
          // name: [{ required: true, message: "请输入学校名称", trigger: "blur" }],
        },
      },
      formItemGroup: [
        {
          option: "input",
          prop: "platform",
          label: "平台名称",
          placeholder: "请输入",
        },
        {
          option: "select",
          prop: "pushType",
          label: "推送类型",
          placeholder: "请选择",
          selectList: [
            {
              value: 1,
              name: "国家级",
            },
            {
              value: 2,
              name: "省级",
            },
            {
              value: 3,
              name: "校级",
            },
          ],
          clearable: true,
        },
        {
          option: "input",
          prop: "unit",
          label: "单位名称",
          placeholder: "请输入",
        },
      ],
    };
  },
  mounted() {
    this.$store.commit("modifyVague", false);
    this.search();
  },
  methods: {
    // 查询表格
    search(obj = {}) {
      this.tableObj.jumpTo = obj.page ? obj.page : 1;
      this.searchData.pageDto.pageNum = obj.page ? obj.page : 1;
      this.searchData.pageDto.pageSize = obj.limit ? obj.limit : 10;
      this.searchData.projectType = this.projectType ? this.projectType : 0;
      this.$axios
        .post(this.$apiurls.getPlatformInfo, this.searchData, {
          loading: false,
        })
        .then((res) => {
          if (res.code === 200) {
            let data = res.data.list;
            for (const item of data) {
              if (item.projectType)
                item.projectTypeName = this.projectTypeList.find(
                  (obj) => obj.value == item.projectType
                ).name;
            }
            this.tableObj.list = data;
            this.tableObj.total = res.data.total;
          }
        })
        .catch(() => {
          this.$store.commit("modifyVague", false);
        });
    },
    // 重置表格
    reset() {
      this.searchData.platForm = "";
      this.projectType = "";
      this.search();
    },
    // 点击新增
    add() {
      // 每次新增打开弹框前都先清除之前的表单数据
      for (const key in this.uploadBox.data) {
        if (key === "id") this.uploadBox.data[key] = null;
        else this.uploadBox.data[key] = "";
      }
      this.uploadBox.title = "添加平台信息";
      this.uploadBox.show = true;
      this.$store.commit("modifyVague", true);
    },
    // 点击编辑按钮
    edit(row) {
      this.uploadBox.title = "修改平台信息";
      this.uploadBox.show = true;
      this.$store.commit("modifyVague", true);
      for (const key in row) {
        this.uploadBox.data[key] = row[key];
      }
    },
    // 添加/修改请求接口
    sureClick() {
      this.uploadBox.data.projectType = this.uploadBox.data.pushType
        ? this.uploadBox.data.pushType
        : 0;
      this.$refs.uploadBox.validate((valid) => {
        if (valid) {
          this.$axios
            .post(this.$apiurls.addPlatformInfo, this.uploadBox.data, {
              loading: false,
            })
            .then((res) => {
              if (res.code === 200) {
                this.$message({
                  message: this.uploadBox.data.id ? "编辑成功！" : "添加成功！",
                  type: "success",
                });
                this.search();
              }
              this.uploadBox.show = false;
              this.$store.commit("modifyVague", false);
            })
            .catch(() => {
              this.$store.commit("modifyVague", false);
            });
        }
      });
    },
    // 点击删除按钮
    cutOut(id) {
      this.$store.commit("modifyVague", true);
      this.$confirm("此操作将永久删除该平台信息, 是否继续?", "删除提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "error",
      }).then(() => {
        this.$axios
          .post(this.$apiurls.delPlatformInfo, id, {
            loading: false,
          })
          .then((res) => {
            if (res.code == 200) {
              this.$message({
                message: "删除成功！",
                type: "success",
              });
              this.search();
            }
            this.$store.commit("modifyVague", false);
          })
          .catch(() => {
            this.$store.commit("modifyVague", false);
          });
      });
    },
    // 打开弹框
    opened() {
      this.$refs.uploadBox.clearValidate();
    },
    // 关闭弹框
    handleClose() {
      this.uploadBox.show = false;
      this.$store.commit("modifyVague", false);
    },
  },
};
</script>

<style lang="scss" src="@/assets/css/popUp.scss" scoped></style>
<style lang="scss" src="@/assets/css/tableList.scss" scoped></style>
<style lang="scss" scoped>
.paginations {
  height: 100%;
}
.addition{
  margin-top: 5px;
}
// 搜索
.table-search-box-hander {
  display: flex;
  justify-content: space-between;
}

.el-form {
  height: 100%;
}

.table_box {
  margin-bottom: 0;
}
</style>
<style lang="scss">
.el-select-dropdown {
  position: absolute;
  z-index: 1001;
  border: none !important;
  max-height: 268px;
  border-radius: 4px;
  background-color: rgba(26, 38, 72);
  box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
  box-sizing: border-box;
  margin: 5px 0;
  .el-select-dropdown__list {
    box-sizing: border-box;
    padding: -1px 0;
    background: rgba(26, 38, 72) !important;
    .el-select-dropdown__item {
      color: #fff !important;
    }
    .hover,
    .el-select-dropdown__item:hover {
      background: transparent;
      border: 1px solid rgba(27, 246, 248);
    }
    .el-select-dropdown__item:hover span {
      font-size: 14px;
      transform: scale(1);
    }
    .selected {
      color: rgba(27, 246, 248);
    }
  }
  .popper__arrow,
  .popper__arrow::after {
    position: absolute;
    display: "";
    width: "";
    height: "";
    border: none;
    border-style: "";
  }
}
.el-input__inner {
  background: rgba(86, 94, 121, 0.59);
  border-color: rgba(86, 94, 121, 0.59);
  color: #fff;
}
</style>
